import React from 'react';
import { LoadingSpinner } from './LoadingSpinner';

interface LoadingPlaceholderProps {
  type?: 'default' | 'form' | 'list' | 'layout';
  className?: string;
}

export const LoadingPlaceholder: React.FC<LoadingPlaceholderProps> = ({ 
  type = 'default',
  className = '' 
}) => {
  if (type === 'form') {
    return (
      <div className={`animate-pulse space-y-4 ${className}`}>
        <div className="h-4 bg-gray-200 rounded w-1/4"></div>
        <div className="h-10 bg-gray-200 rounded"></div>
        <div className="h-4 bg-gray-200 rounded w-1/4"></div>
        <div className="h-10 bg-gray-200 rounded"></div>
        <div className="h-4 bg-gray-200 rounded w-1/4"></div>
        <div className="h-10 bg-gray-200 rounded"></div>
        <div className="h-10 bg-blue-200 rounded w-full mt-6"></div>
      </div>
    );
  }

  if (type === 'list') {
    return (
      <div className={`animate-pulse space-y-3 ${className}`}>
        {[...Array(5)].map((_, i) => (
          <div key={i} className="h-16 bg-gray-200 rounded"></div>
        ))}
      </div>
    );
  }

  return (
    <div className={`flex justify-center items-center p-8 ${className}`}>
      <LoadingSpinner size="lg" />
    </div>
  );
};